export default "../css/8280812866f4b2948ea09b52a65d0ab0.ttf";